import {mapGetters, mapMutations} from 'vuex';
import vueSlider from 'vue-slider-component';
import router from '../../router';
import optionsSlider from './options-slider.json';
import {isUri} from '../../helper';
import './swiped-events.min';
import {HYDRA_DESCRIPTION} from '../../constants/hydra';

export default {
    components: {
        vueSlider
    },
    data() {
        return {
            optionsSlider: optionsSlider,
            helpTexts: false,
            showComplement: false,
        };
    },
    computed: {
        ...mapGetters('question/show/', [
            'zeroPool',
            'loading',
            'item',
            'next',
            'selectedAnswer',
            'isFantasy',
            'isAction',
            'detectChange',
            'bookmark',
        ]),
        ...mapGetters('loading/loading/', [
            'loading',
        ]),
        gaugeLevel: {
            get() {
                return this.$store.state.question.show.gaugeLevel;
            },
            set(value) {
                let color = this.optionsSlider.color;
                this.optionsSlider.processStyle.backgroundColor = color[value];
                this.optionsSlider.sliderStyle.backgroundColor = color[value];
                this.setGaugeLevel(value);
            },
        },
    },
    watch: {
        $route() {
            this.retrieve();
        },
    },
    methods: {
        ...mapMutations('question/show', {
            setSelectedAnswer: 'QUESTION_SET_SELECTED_ANSWER',
            setIsAction: 'QUESTION_SET_IS_ACTION',
            setIsFantasy: 'QUESTION_SET_IS_FANTASY',
            setGaugeLevel: 'QUESTION_SET_GAUGE_LEVEL',
        }),
        previousQuestion: function() {
            if (this.detectChange && !confirm(this.$t('question.skipConfirm'))) {
                return;
            }
            router.replace({name: 'QuestionShow', params: {id: this.item['previousQuestionId']}});
        },
        isUri,
        submitAnswer: function() {
            this.$store
                .dispatch('question/show/submitAnswer', {})
                .then(response => {
                    if (response !== false) {
                        if (this.next) {
                            router.push({name: 'QuestionShow', params: {id: this.next}});
                        } else {
                            router.push({name: 'QuestionFinished'});
                        }
                    }
                });
        },
        nextQuestion: function() {
            if (this.detectChange && !confirm(this.$t('question.skipConfirm'))) {
                return;
            }
            router.push({name: 'QuestionShow', params: {id: this.next}});
        },
        swipedLeft() {
            if (this.next) {
                this.nextQuestion();
            }
        },
        swipedRight() {
            if (this.item['previousQuestionId']) {
                this.previousQuestion();
            }
        },
        eventKeyboard(event) {
            if (event.key === 'ArrowLeft' && this.item['previousQuestionId']) {
                this.previousQuestion();
            }
            if (event.key === 'ArrowRight' && this.next) {
                this.nextQuestion();
            }
        },
        gesture() {
            document.addEventListener('keydown', this.eventKeyboard);
            document.addEventListener('swiped-right', this.swipedRight);
            document.addEventListener('swiped-left', this.swipedLeft);
        },
        setBookmark() {
            this.$store.dispatch('question/show/updateBookmark', {bookmark: !this.bookmark});
        },
        retrieve() {
            return this.$store
                .dispatch('question/show/retrieve', this.$route.params)
                .then(() => {
                    this.$store.dispatch('app/giveAway/getGiveAwayQuestion')
                        .then(response => {
                            if (response.isGiveAway) {
                                this.$emit('giveAway');
                            }
                        });
                })
                .catch((e) => {
                    if (e.response.data[HYDRA_DESCRIPTION] === 'question.form.errors.noQuestionAvailable') {
                        router.push({name: 'PostList'});
                        return;
                    }
                    if (e.response.data[HYDRA_DESCRIPTION] === 'question.zeroPool.error') {
                        let route = {name: 'QuestionZeroPool'};
                        if (this.item['previousQuestionId']) {
                            route = {
                                ...route,
                                ...{
                                    params: {
                                        previousQuestionId: this.item.id
                                    }
                                }
                            };
                        }
                        router.push(route);
                        return;
                    }
                    router.push({name: 'QuestionFinished'});
                });
        },
    },
    created() {
        this.retrieve().then(() => {
            this.gesture();
        });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.eventKeyboard);
        document.removeEventListener('swiped-right', this.swipedRight);
        document.removeEventListener('swiped-left', this.swipedLeft);
    },
};



// WEBPACK FOOTER //
// ./src/components/question/show.js